import constants from './constants';

const { NAMESPACE } = constants;

const CHANGE_GPS_LOCATION = `${NAMESPACE}/CHANGE_GPS_LOCATION` as const;
const RESET_GPS_LOCATION = `${NAMESPACE}/RESET_GPS_LOCATION` as const;
const SUBMIT_GPS_LOCATION = `${NAMESPACE}/SUBMIT_GPS_LOCATION` as const;

export default {
  CHANGE_GPS_LOCATION,
  RESET_GPS_LOCATION,
  SUBMIT_GPS_LOCATION,
};
